module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"form":"Formular","create form":"Formular erstellen","click to edit":"Klicken Sie hier zum Editieren.","data saved":"Ihre Daten wurden erfolgreich gespeichert."}}')
  delete Component.options._Ctor
}
